import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useProjectData } from "../../shared/hooks";

interface ProjectNavInterface {
  openTab: number;
  setOpenTab: (x: number) => void;
}

const ProjectNav: React.FC<ProjectNavInterface> = ({ openTab, setOpenTab }) => {
  const { id } = useParams();

  const navigate = useNavigate();
  const location = useLocation();
  const {projectData, projectId, projectDetails} = useProjectData();

  const [currentTab, setCurrentTab] = useState(projectId);

  useEffect(() => {
    setCurrentTab(projectId);
  }, [location.pathname]);

  return (
    <>
      <div className="px-4 pt-6 bg-white border-b lg:px-8 sm:px-6 ">
        <select
          name="modules"
          id="select-module"
          className=" border border-gray-300 text-gray-900 rounded-md focus:ring-blue-500 focus:border-blue-500 "
          onChange={(e) =>
            navigate(`/localization/projects/${e.target.value}`)
          }
          defaultValue={currentTab}
        >
          {Object.values(projectDetails).map((item) => (
            <option value={item.module} className="p-2" key={item.module}>
              {item.module}
            </option>
          ))}
        </select>

        <div>
          <ul
            role="tablist"
            className=" md:grid md:gap-4 md:grid-cols-5 md:place-items-start mt-4"
          >
            <li>
              <Link
                to="#"
                className={`flex items-center px-2 py-5 -mb-px text-center text-gray-600 border-b-2  lg:px-4 whitespace-nowrap hover:border-gray-300
              ${openTab === 1 &&
                  "text-primary border-primary hover:border-primary"
                  }`}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(1);
                }}
                data-toggle="tab"
                role="tablist"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 4.875V3H13V4.875"
                    stroke={openTab === 1 ? "#546CCC" : "#565759"}
                    strokeLinecap="round"
                  />
                  <path
                    d="M6.125 13H9.875"
                    stroke={openTab === 1 ? "#546CCC" : "#565759"}
                    strokeLinecap="round"
                  />
                  <path
                    d="M8 3V13"
                    stroke={openTab === 1 ? "#546CCC" : "#565759"}
                    strokeLinecap="round"
                  />
                </svg>

                <span
                  className={`${openTab === 1 && "text-primary"} mx-1 text-sm`}
                >
                  Translations
                </span>
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className={`flex items-center px-2 py-5 -mb-px text-center text-gray-600 border-b-2  lg:px-4 whitespace-nowrap hover:border-gray-300
              ${openTab === 2 && "text-primary border-b-2 border-primary"}`}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(2);
                }}
                data-toggle="tab"
                role="tablist"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 14.625C3 14.1277 3.19754 13.6508 3.54917 13.2992C3.90081 12.9475 4.37772 12.75 4.875 12.75H15"
                    stroke={openTab === 2 ? "#546CCC" : "#565759"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                  <path
                    d="M4.875 1.5H15V16.5H4.875C4.37772 16.5 3.90081 16.3025 3.54917 15.9508C3.19754 15.5992 3 15.1223 3 14.625V3.375C3 2.87772 3.19754 2.40081 3.54917 2.04917C3.90081 1.69754 4.37772 1.5 4.875 1.5V1.5Z"
                    stroke={openTab === 2 ? "#546CCC" : "#565759"}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>

                <span
                  className={`${openTab === 2 && "text-primary"} mx-1 text-sm`}
                >
                  Glossary
                </span>
              </Link>
            </li>
            <li>
              <Link
                to={`#languages`}
                className={`flex items-center px-2 py-5 -mb-px text-center text-gray-600 border-b-2  lg:px-4 whitespace-nowrap hover:border-gray-300
              ${openTab === 3 && "text-primary border-b-2 border-primary"}`}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(3);
                }}
                data-toggle="tab"
                role="tablist"
              >
                <svg
                  width="19"
                  height="18"
                  className="mx-1"
                  viewBox="0 0 19 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.8139 6.62476H11.3544V3.62119C11.3537 3.19151 11.1758 2.77947 10.8597 2.47565C10.5438 2.1717 10.1152 2.00066 9.66839 2H3.18601C2.73916 2.00068 2.31064 2.17171 1.99469 2.47565C1.67859 2.77947 1.50071 3.19151 1.50002 3.62119V7.5187C1.49833 7.84137 1.5989 8.15685 1.78862 8.4231C2.40587 9.57936 5.34511 11.3135 5.37447 11.3393C5.41622 11.3641 5.46432 11.3774 5.51341 11.3778C5.57618 11.3771 5.63669 11.3553 5.68437 11.3161C5.7714 11.2448 5.80144 11.128 5.75927 11.0259C5.52441 10.4124 5.3457 9.78063 5.22481 9.13731H7.6457V12.1434C7.64641 12.573 7.82427 12.9846 8.14036 13.2882C8.4566 13.5916 8.88498 13.7621 9.33169 13.7621H13.7753C13.6544 14.4052 13.4757 15.0372 13.2409 15.6505C13.1998 15.7521 13.2299 15.8674 13.3156 15.9383C13.3633 15.9775 13.424 15.9993 13.4867 16C13.5358 15.9996 13.5839 15.9863 13.6257 15.9615C13.655 15.9434 16.5943 14.2015 17.2115 13.0453C17.4011 12.779 17.5018 12.4635 17.5 12.1409V8.2458C17.4993 7.81598 17.3214 7.40407 17.0055 7.10012C16.6894 6.79631 16.261 6.62527 15.814 6.62461L15.8139 6.62476ZM6.69192 8.62368H4.90703C4.82888 8.62368 4.75469 8.65651 4.70391 8.71361C4.65257 8.77084 4.63014 8.84693 4.64255 8.92167C4.73452 9.45402 4.85851 9.98068 5.01394 10.4992C4.08946 9.89797 2.63324 8.86514 2.26976 8.1997C2.26158 8.18179 2.25171 8.16457 2.24042 8.14829C2.10572 7.96397 2.03392 7.7441 2.03463 7.51882V3.62131C2.03533 3.32781 2.15692 3.04663 2.37273 2.83914C2.58854 2.63148 2.88108 2.5147 3.18617 2.51403H9.66855C9.97379 2.51471 10.2662 2.63148 10.482 2.83914C10.6979 3.04665 10.8194 3.32781 10.8201 3.62131V6.62488H9.33184C8.82208 6.62501 8.3398 6.84704 8.01991 7.22872C7.63852 7.2294 7.26259 7.14124 6.92435 6.9717C7.42309 6.42876 7.71677 5.73988 7.75797 5.01645H8.09466C8.2422 5.01645 8.36196 4.90144 8.36196 4.75957C8.36196 4.6177 8.2422 4.50268 8.09466 4.50268H6.70528V3.69079C6.70528 3.54878 6.58567 3.43377 6.43798 3.43377C6.29044 3.43377 6.17083 3.54878 6.17083 3.69079V4.49494H4.77877C4.63109 4.49494 4.51148 4.60996 4.51148 4.75183C4.51148 4.8937 4.63109 5.00885 4.77877 5.00885H7.22097C7.18204 5.60387 6.93858 6.16959 6.52882 6.61716L6.48608 6.65568C6.18888 6.37654 5.96065 6.03666 5.8182 5.66135C5.76502 5.5287 5.61015 5.46251 5.47206 5.51365C5.33411 5.56478 5.26541 5.7137 5.31845 5.84635C5.47784 6.26246 5.72526 6.6421 6.0453 6.96137C5.65571 7.15071 5.22309 7.24348 4.7867 7.23114C4.63916 7.23114 4.51955 7.34629 4.51955 7.48816C4.51955 7.63003 4.63916 7.74504 4.7867 7.74504C5.38605 7.76308 5.97774 7.61213 6.4888 7.31088C6.8647 7.54092 7.29281 7.68022 7.73671 7.71682C7.6769 7.88202 7.64615 8.05562 7.64587 8.23059V8.60833L6.69192 8.62368ZM16.9658 12.1438C16.9665 12.3691 16.8946 12.5889 16.76 12.7732C16.7486 12.788 16.7396 12.8046 16.7333 12.8221C16.37 13.4875 14.9111 14.5229 13.9865 15.1345C14.1419 14.6159 14.2659 14.0892 14.3579 13.5569C14.3703 13.4822 14.3477 13.4061 14.2964 13.3487C14.2457 13.2918 14.1716 13.2588 14.0934 13.2588H9.33201C9.02705 13.2588 8.7345 13.1426 8.51857 12.9355C8.30276 12.7283 8.18103 12.4473 8.18032 12.1541V8.24615C8.18103 7.95264 8.30262 7.67133 8.51843 7.46383C8.73424 7.25632 9.02678 7.13954 9.33201 7.13886H15.8144C16.1196 7.13954 16.4122 7.25632 16.628 7.46383C16.8438 7.67135 16.9654 7.95265 16.9661 8.24615L16.9658 12.1438ZM12.8323 8.19209C12.8221 8.17053 12.8086 8.15073 12.7921 8.13309C12.7921 8.13309 12.7921 8.11506 12.7734 8.10746L12.7735 8.10733C12.7641 8.10081 12.7543 8.09471 12.744 8.08942C12.7271 8.07518 12.7082 8.06311 12.688 8.05334C12.6738 8.05212 12.6594 8.05212 12.6453 8.05334C12.6265 8.05212 12.6078 8.05212 12.5892 8.05334C12.5656 8.05511 12.5422 8.05944 12.5196 8.06623H12.4903C12.4653 8.07681 12.4419 8.09064 12.4208 8.10732L12.402 8.12021L12.3806 8.151H12.3807C12.3667 8.16795 12.3542 8.18599 12.3433 8.20498L10.7401 12.0591C10.7139 12.1224 10.7149 12.1932 10.7429 12.2559C10.771 12.3186 10.8238 12.3679 10.8898 12.393C10.9211 12.4054 10.9548 12.4116 10.9887 12.4111C11.0981 12.4112 11.1966 12.347 11.2371 12.2492L11.702 11.1265H13.4788L13.9464 12.2492H13.9465C13.987 12.347 14.0855 12.4112 14.1951 12.4111C14.2289 12.4112 14.2623 12.4051 14.2939 12.393C14.3598 12.3679 14.4127 12.3186 14.4408 12.2559C14.4688 12.1932 14.4698 12.1224 14.4435 12.0591L12.8323 8.19209ZM11.9051 10.5996L12.5811 8.97837L13.2545 10.5996H11.9051Z"
                    stroke={openTab === 3 ? "#546CCC" : "#565759"}
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    fill="#565759"
                  />
                </svg>

                <span
                  className={`${openTab === 3 && "text-primary"} mx-1 text-sm`}
                >
                  Languages
                </span>
              </Link>
            </li>
            <li>
              <Link
                to={`#files`}
                className={`flex items-center px-2 py-5 -mb-px text-center text-gray-600 border-b-2  lg:px-4 whitespace-nowrap hover:border-gray-300
              ${openTab === 4 && "text-primary border-b-2 border-primary"}`}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(4);
                }}
                data-toggle="tab"
                role="tablist"
              >
                <svg
                  width="15"
                  height="16"
                  className="mx-1"
                  viewBox="0 0 15 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.75 1.75H3.75C3.41848 1.75 3.10054 1.8817 2.86612 2.11612C2.6317 2.35054 2.5 2.66848 2.5 3V13C2.5 13.3315 2.6317 13.6495 2.86612 13.8839C3.10054 14.1183 3.41848 14.25 3.75 14.25H11.25C11.5815 14.25 11.8995 14.1183 12.1339 13.8839C12.3683 13.6495 12.5 13.3315 12.5 13V5.5L8.75 1.75Z"
                    stroke={openTab === 4 ? "#546CCC" : "#565759"}
                    strokeLinecap="round"
                  />
                  <path
                    d="M8.75 1.75V5.5H12.5"
                    stroke={openTab === 4 ? "#546CCC" : "#565759"}
                    strokeLinecap="round"
                  />
                  <path
                    d="M10 8.625H5"
                    stroke={openTab === 4 ? "#546CCC" : "#565759"}
                    strokeLinecap="round"
                  />
                  <path
                    d="M10 11.125H5"
                    stroke={openTab === 4 ? "#546CCC" : "#565759"}
                    strokeLinecap="round"
                  />
                  <path
                    d="M6.25 6.125H5.625H5"
                    stroke={openTab === 4 ? "#546CCC" : "#565759"}
                    strokeLinecap="round"
                  />
                </svg>

                <span
                  className={`${openTab === 4 && "text-primary"} mx-1 text-sm`}
                >
                  Files
                </span>
              </Link>
            </li>
            {/* <li>
              <Link
                to={`/localization/projects/${id}/collaborators`}
                className={`flex items-center px-2 py-5 -mb-px text-center text-gray-600 border-b-2  lg:px-4 whitespace-nowrap hover:border-gray-300
              ${openTab === 5 && "text-primary border-b-2 border-primary"}`}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(5);
                }}
                data-toggle="tab"
                role="tablist"
              >
                <svg
                  width="16"
                  height="16"
                  className="mx-1"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_814_15693)">
                    <path
                      d="M11.125 13.625V12.375C11.125 11.712 10.8616 11.0761 10.3928 10.6072C9.92393 10.1384 9.28804 9.875 8.625 9.875H3.625C2.96196 9.875 2.32607 10.1384 1.85723 10.6072C1.38839 11.0761 1.125 11.712 1.125 12.375V13.625"
                      stroke={openTab === 5 ? "#546CCC" : "#565759"}
                      strokeLinecap="round"
                    />
                    <path
                      d="M6.125 7.375C7.50571 7.375 8.625 6.25571 8.625 4.875C8.625 3.49429 7.50571 2.375 6.125 2.375C4.74429 2.375 3.625 3.49429 3.625 4.875C3.625 6.25571 4.74429 7.375 6.125 7.375Z"
                      stroke={openTab === 5 ? "#546CCC" : "#565759"}
                      strokeLinecap="round"
                    />
                    <path
                      d="M14.875 13.6248V12.3748C14.8746 11.8209 14.6902 11.2828 14.3509 10.845C14.0115 10.4072 13.5363 10.0945 13 9.95605"
                      stroke={openTab === 5 ? "#546CCC" : "#565759"}
                      strokeLinecap="round"
                    />
                    <path
                      d="M10.5 2.45605C11.0378 2.59374 11.5144 2.90649 11.8548 3.345C12.1952 3.7835 12.3799 4.32282 12.3799 4.87793C12.3799 5.43304 12.1952 5.97235 11.8548 6.41086C11.5144 6.84937 11.0378 7.16212 10.5 7.2998"
                      stroke={openTab === 5 ? "#546CCC" : "#565759"}
                      strokeLinecap="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_814_15693">
                      <rect
                        width="15"
                        height="15"
                        fill="white"
                        transform="translate(0.5 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>

                <span
                  className={`${openTab === 5 && "text-primary"} mx-1 text-sm`}
                >
                  Collaborators
                </span>
              </Link>
            </li> */}
          </ul>
        </div>
      </div>
    </>
  );
};

export default ProjectNav;
